import React from "react";
import { Typography } from "@material-ui/core";
const GlobalPartner = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Global Partner
      </Typography>
      <Typography paragraph variant="h5">
        Bring a potential customer who is happy to use the Invifo platform and
        earn a passive income share from Invifo.
      </Typography>
      <Typography paragraph variant="body1">
        Invifo Global Partner is a worldwide partner who shares the Invifo
        Platform solution with new potential customers to run their core
        business, the partners who share the same passion and vision to seek
        millions of benefits of the Invifo solutions.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Reasons why companies want to become Invifo Global Partners.
      </Typography>
      <Typography paragraph variant="body1">
        For the majority of partners of the existing system provider, the
        partners only get a one-time small profit or even got nothing when
        successfully bringing a potential customer to use the system solution.
        But Invifo offers something more than that, the Invifo partners are
        entitled to have a passive share with a lifetime agreement which can be
        inherited anytime as long as the customer that they bring still
        generating revenue for Invifo. There are tons of benefits offered for
        being an Invifo Global Partner.
      </Typography>
      <div className="row justify-content-center mt-5">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-wallet fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Passive Share
              </Typography>
              <Typography align="center">
                We offer something you cannot refuse. Every time the Invifo
                Global Partners bring in a lead or potential customer who is
                happy to sign a business deal by using the Invifo Platform, they
                are entitled to have a passive share. The partners will get paid
                a maximum of 10% of every monthly revenue made by the customers
                that they bring to Invifo depends on the partnership level.
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-file-signature fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                Lifetime Contract
              </Typography>
              <Typography align="center">
                We propose a clause better than the others. The Invifo Global
                Partners will always get passive shares or profits as long as
                the customers they bring still generating revenue for Invifo.
                The Global Partner contract is also able to be inherited to
                their children, relatives, or other precious heirs.
              </Typography>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
              <Typography component="span" align="center">
                <i className="fas fa-money-check-alt fa-4x kt-font-brand"></i>
              </Typography>
              <Typography
                variant="h6"
                align="center"
                className="kt-font-bolder mt-3"
              >
                On-Time Payment Share
              </Typography>
              <Typography align="center">
                We give the best convenience and let the partners enjoy the
                time. The only thing that the Invifo Global Partner can do after
                their potential customers have a deal with us is sit, enjoy
                life, and wait for the profits. Invifo will take care of the
                rest and be ready to share the profits with the valuable
                partners in local currency.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GlobalPartner;
